// extracted by mini-css-extract-plugin
module.exports = {"adsWrapper":"adglare_adsWrapper__-4Ito","loading":"adglare_loading__3eteM"};